import React, { Component } from 'react';
import { db } from '../firebase';
import { Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

class UserDetailsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inGameName: this.props.inGameName,
      ethWallet: this.props.ethWallet,
      error: null
    };
  }

  onSubmit = (event) => {
    const { inGameName, ethWallet } = this.state;

    db.updateUser(this.props.userId,inGameName, ethWallet)

    event.preventDefault();
  }

  render() {
    const {
      inGameName,
      ethWallet,
      error,
    } = this.state;

    var buttonStyle={
      marginTop: 10
    }

    return (
      <Form onSubmit={this.onSubmit}>
      <h5>User Name: {this.props.userName}</h5>
      <h5>Email: {this.props.authEmail}</h5>

      <FormGroup row>
        <Label  for="inGameName" sm={2}>In Game Name</Label>
        <Col sm={10}>
        <Input id="inGameName"
          value={inGameName}
          onChange={event => this.setState(byPropKey('inGameName', event.target.value))}
          type="text"
          placeholder="In Game Name"
        />
        </Col>
        </FormGroup>

        <FormGroup row>
          <Label  for="ethWallet" sm={2}>Public Eth Wallet</Label>
          <Col sm={10}>
          <Input id="ethWallet"
            value={ethWallet}
            onChange={event => this.setState(byPropKey('ethWallet', event.target.value))}
            type="text"
            placeholder="Public Eth Wallet Address"
          />
          </Col>
          </FormGroup>


        <Button style={buttonStyle} type="submit">
          Update
        </Button>
        { error && <p>{error.message}</p> }
      </Form>
    );
  }
}

export default UserDetailsForm;



// WEBPACK FOOTER //
// ./src/Authentication/UserDetails.js